import React from 'react';
import { Grid } from '@mui/material';
import { StyledFab } from '#component/device/general/styles';

const FloatingActionButton = props => {
  const {
    buttonColor,
    onClickFabButton,
    buttonIcon,
    buttonName,
    isPagePaginated,
    textColor } = props;

  return (
    <Grid container justifyContent="center">
      <StyledFab
        variant="contained"
        startIcon={buttonIcon}
        color={buttonColor}
        onClick={onClickFabButton}
        size="large"
        style={{
          color: textColor,
          ...(isPagePaginated ? { marginBottom: '60px' } : {})
        }}
      >
        {buttonName}
      </StyledFab>
    </Grid>
  );
};

export default FloatingActionButton;
